import React from 'react';
import { FooterSocialMediaColumn } from '../../../../sanity/sanity.types';
import { NavTrackingProvider } from '../analytics';
import { socialIconLink } from '../navEvents';
import SocialMediaLink from './SocialMediaLink';

type Props = {
  links: FooterSocialMediaColumn['links'];
};

const SocialMediaGroup = ({ links }: Props) => {
  return (
    <ul className="ml-0 mb-32 flex list-none gap-16">
      {links &&
        links.map((link, index) => (
          <li key={link._key}>
            <NavTrackingProvider item={socialIconLink(link._key, link.site, index)}>
              <SocialMediaLink {...link} />
            </NavTrackingProvider>
          </li>
        ))}
    </ul>
  );
};

export default SocialMediaGroup;
